import React from 'react';
import { MapPin } from 'lucide-react';
export function LocalSEOSection() {
  return <section className="py-20 bg-white border-t border-neutral-100" data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="flex flex-col md:flex-row items-center justify-between gap-12 bg-neutral-900 rounded-3xl p-8 md:p-12 overflow-hidden relative" data-id="element-116">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/10 rounded-full blur-3xl -mr-16 -mt-16 pointer-events-none" data-id="element-117"></div>

          <div className="relative z-10 max-w-2xl" data-id="element-118">
            <div className="flex items-center space-x-2 text-red-500 mb-4 font-medium" data-id="element-119">
              <MapPin className="w-5 h-5" data-id="element-120" />
              <span className="uppercase tracking-wider text-sm" data-id="element-121">
                Sainte-Catherine, Québec
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-122">
              Cours de Taekwondo à Sainte-Catherine
            </h2>
            <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-123">
              Vous recherchez une école de taekwondo à Sainte-Catherine? HLD
              Taekwondo offre des cours professionnels pour enfants, adolescents
              et adultes. Située sur la Route 132, notre école dessert fièrement
              les familles de Sainte-Catherine et de la Rive-Sud de Montréal.
            </p>
          </div>

          <div className="relative z-10 shrink-0" data-id="element-124">
            <a href="https://maps.google.com/?q=5144+Route+132+Sainte-Catherine+QC" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 border border-white/20 text-base font-medium rounded-full text-white hover:bg-white hover:text-neutral-900 transition-all duration-300" data-id="element-125">
              Voir sur la carte
            </a>
          </div>
        </div>
      </div>
    </section>;
}